import { Provider, useDispatch } from "react-redux";
import React, { Fragment, useEffect, useState } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useLazyGetUserInfoQuery, useLazyGetAllUserRolesQuery } from "app/redux/UserManager/userManagerApi";
import {userRoleListAction} from "app/redux/UserManager/userManagerSlice";
import { getToken } from "app/auth/getToken";
import { Logout } from "app/auth/logout";

// ALL PAGE ROUTES
import routes from "./routes";
// REDUX STORE
import { store } from "./redux/Store";
// FAKE DB
// import "../fake-db";

function App(props) {
  const { accounts, inProgress } = useMsal();
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated();
  const [getuserInfo] = useLazyGetUserInfoQuery();
  const [getAllUserRoles] = useLazyGetAllUserRolesQuery();
  const [IsRoleFetch, setIsRoleFetch] = useState(false);

  useEffect(() => {
    // Handle redirect response and set active account
    props.pca.handleRedirectPromise().then((resp) => {
      if (resp && resp.account) {
        props.pca.setActiveAccount(resp.account);
      } else {
        const currentAccounts = props.pca.getAllAccounts();
        if (currentAccounts && currentAccounts.length === 1) {
          props.pca.setActiveAccount(currentAccounts[0]);
        }
      }
    }).catch(err => {
      sessionStorage.setItem('idTokenHint', '');
      console.error(err);
    });
  }, []);

  useEffect(() => {
    const id_token_hint = sessionStorage.getItem('idTokenHint');
    if (inProgress !== InteractionStatus.None) return;

    async function login() {
      if (!isAuthenticated) {
        if (id_token_hint && id_token_hint !== "") {
          console.log("Redirecting with id_token_hint");
          await props.pca.loginRedirect({
            scopes: ['openid', 'profile', process.env.REACT_APP_API_SCOPE],
            extraQueryParameters: { "id_token_hint": id_token_hint },
            authority: 'https://StyretB2CTenant.b2clogin.com/StyretB2CTenant.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL'
          });
        } else {
          await props.pca.loginRedirect({
            scopes: ['openid', 'profile', process.env.REACT_APP_API_SCOPE]
          });
        }
        return;
      } else {
        var token = await getToken();
        if (token === undefined) {
          await Logout();
        }
      }
      if (isAuthenticated) {
        async function fetchMyAPI() {
          await getuserInfo();
          await getAllUserRoles();
          getAllUserRoles().then(
            (result) => {
              setIsRoleFetch(true);
              if(result.isSuccess){
                if (result.data && result.data.length > 0) {
                  let resultData = result.data;
                  dispatch(
                    userRoleListAction({
                      userRoleList: resultData,
                    })
                  );
                }
              }
            });
          }
        fetchMyAPI();
      }
    }
    login();
  }, [isAuthenticated, inProgress]);

  if (isAuthenticated) {
    return (
      <Fragment>
        {IsRoleFetch ? (
          <Provider store={store}>
            <RouterProvider router={routes} />
            <ToastContainer />
          </Provider>
        ) : ""}
      </Fragment>
    );
  } else {
    return <div className="App">Logging in...</div>;
  }


}

export default App;
